import { render, staticRenderFns } from "./pointorder.vue?vue&type=template&id=85344b9c&scoped=true&"
import script from "./pointorder.vue?vue&type=script&lang=js&"
export * from "./pointorder.vue?vue&type=script&lang=js&"
import style0 from "./pointorder.vue?vue&type=style&index=0&id=85344b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85344b9c",
  null
  
)

export default component.exports